<template>
  <div>
    <section class="section-header-info">
      <div class="container big-container">
        <div class="row mt-20">
          <div class="col-sm-4">
            <div class="mini-form">
              <ul class="nav nav-tabs nav-justified tabs-mini-form">
                <li class="active">
                  <a
                    ref="linkrange"
                    href="#range"
                    data-toggle="tab"
                    @click="activeTab = 'range'"
                  >
                    Range
                  </a>
                </li>
                <li>
                  <a
                    ref="linkflex"
                    href="#flex"
                    data-toggle="tab"
                    @click="activeTab = 'flex'"
                  >
                    Flex
                  </a>
                </li>
                <li>
                  <a
                    ref="linkannual"
                    href="#annual"
                    data-toggle="tab"
                    @click="activeTab = 'annual'"
                  >
                    Annual
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div id="range" class="tab-pane fade in active">
                  <div v-if="activeTab.toLowerCase() === 'range'">
                    <div class="header-pickperiod">
                      Add periodic dates
                      <span>
                        This feature is used to manage peak periods with a start
                        and end date (date range) scheme.
                      </span>
                    </div>
                    <form action="#" id="peak-period-form" role="form">
                      <div class="form-group w60">
                        <label>
                          Select Date
                          <span class="--blue25">( in Range )</span>
                        </label>
                        <VueCtkDateTimePicker
                          v-model="model.dateRange"
                          color="#025BC5"
                          format="YYYY-MM-DD"
                          formatted="MMM DD"
                          range
                          auto-close
                          no-shortcuts
                          no-label
                          no-header
                          no-button
                          no-button-now
                        />
                        <small
                          class="form-text text-danger"
                          v-if="validationErrors.dateRange"
                          v-text="validationErrors.dateRange"
                        ></small>
                      </div>
                      <div class="form-group">
                        <label for>Event Title</label>
                        <textarea
                          class="form-control"
                          rows="3"
                          name="title"
                          v-model="model.title"
                          maxlength="100"
                          required
                        ></textarea>
                        <small
                          class="form-text text-danger"
                          v-if="validationErrors.title"
                          v-text="validationErrors.title"
                        ></small>
                        <div
                          v-if="
                            model.title !== null && model.title !== undefined
                          "
                          class="text-right word-count"
                        >
                          {{ model.title.length }} from 100 characters
                        </div>
                      </div>
                      <div class="modal-footer pt-10">
                        <div class="row">
                          <div class="col-sm-6">
                            <button
                              type="submit"
                              class="btn btn-primary pull-left"
                              @click.prevent="saveItem()"
                            >
                              Save Period Date
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <button
                              type="button"
                              class="btn btn-default pull-right"
                              @click.prevent="resetModel()"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- /.modal-footer -->
                    </form>
                  </div>
                </div>
                <div id="flex" class="tab-pane fade">
                  <div v-if="activeTab.toLowerCase() === 'flex'">
                    <div class="header-pickperiod">
                      Add flex dates
                      <span>
                        This feature is used to manage peak periods with
                        flexible date scheme.
                      </span>
                    </div>
                    <form action="#" id="peak-period-form" role="form">
                      <div
                        class="form-group"
                        v-for="(input, index) in flexDates"
                        :key="index"
                      >
                        <label v-if="index === 0">Select Date</label>
                        <label v-else>Other Date</label>
                        <div class="row">
                          <div class="col-sm-9 prz">
                            <VueCtkDateTimePicker
                              :id="index"
                              v-model="input.startDate"
                              color="#025BC5"
                              format="YYYY-MM-DD"
                              formatted="LL"
                              auto-close
                              only-date
                              no-label
                              no-header
                              no-button
                              no-button-now
                            />
                          </div>
                          <div
                            class="col-sm-3 text-center"
                            v-if="flexDates.length > 1"
                          >
                            <button
                              type="button"
                              class="btn btn-remove"
                              @click="deleteFlex(index)"
                            >
                              <i class="ic-close"></i>
                            </button>
                          </div>
                        </div>
                        <!-- /.row -->
                      </div>
                      <!-- /.form-group -->
                      <div class="btn btn-flat mb-25" @click="addFlex()">
                        &plus; Add dates
                      </div>
                      <div class="form-group">
                        <label for>Event Title</label>
                        <textarea
                          class="form-control"
                          rows="3"
                          name="title"
                          v-model="model.title"
                          maxlength="100"
                          required
                        ></textarea>
                        <small
                          class="form-text text-danger"
                          v-if="validationErrors.title"
                          v-text="validationErrors.title"
                        ></small>
                        <div
                          v-if="
                            model.title !== null && model.title !== undefined
                          "
                          class="text-right word-count"
                        >
                          {{ model.title.length }} from 100 characters
                        </div>
                      </div>
                      <div class="modal-footer pt-10">
                        <div class="row">
                          <div class="col-sm-6">
                            <button
                              type="submit"
                              class="btn btn-primary pull-left"
                              @click.prevent="saveItem()"
                            >
                              Save Date
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <button
                              type="button"
                              class="btn btn-default pull-right"
                              @click.prevent="resetModel()"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- /.modal-footer -->
                    </form>
                  </div>
                </div>
                <div id="annual" class="tab-pane fade">
                  <div v-if="activeTab.toLowerCase() === 'annual'">
                    <div class="header-pickperiod">
                      Add annual dates
                      <span>
                        This feature is used to manage peak periods for
                        recurring dates every years.
                      </span>
                    </div>
                    <form action="#" id="peak-period-form" role="form">
                      <div class="form-group w60">
                        <label>Select Date</label>
                        <VueCtkDateTimePicker
                          v-model="model.startDate"
                          color="#025BC5"
                          format="YYYY-MM-DD"
                          formatted="LL"
                          auto-close
                          only-date
                          no-label
                          no-header
                          no-button
                          no-button-now
                        />
                      </div>
                      <div class="form-group">
                        <label for>Holiday / Event Title</label>
                        <textarea
                          class="form-control"
                          rows="3"
                          name="title"
                          v-model="model.title"
                          maxlength="100"
                          required
                        ></textarea>
                        <small
                          class="form-text text-danger"
                          v-if="validationErrors.title"
                          v-text="validationErrors.title"
                        ></small>
                        <div
                          v-if="
                            model.title !== null && model.title !== undefined
                          "
                          class="text-right word-count"
                        >
                          {{ model.title.length }} from 100 characters
                        </div>
                      </div>
                      <div class="modal-footer pt-10">
                        <div class="row">
                          <div class="col-sm-6">
                            <button
                              type="submit"
                              class="btn btn-primary pull-left"
                              @click.prevent="saveItem()"
                            >
                              Save Annual Date
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <button
                              type="button"
                              class="btn btn-default pull-right"
                              @click.prevent="resetModel()"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- /.modal-footer -->
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.content-header-info -->
          </div>
          <!-- /.col-sm-4   -->

          <div class="col-sm-8">
            <div>
              <div class="event-calendar-header" style="border-top: unset">
                <div class="row">
                  <div class="col-sm-5">
                    <h3>Event Calendar</h3>
                    <p class="info-text">
                      Annual day may differ by other countries.
                    </p>
                  </div>
                  <div class="col-sm-7 pull-right">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="search-wrapper-peak-period">
                          <i class="ic-search"></i>
                          <input
                            type="search"
                            class="form-control"
                            placeholder="Search Title/Event"
                            v-model="searchFilter"
                            @keyup="onSearchTitle()"
                          />
                        </div>
                      </div>
                      <div class="col-sm-7">
                        <div class="form-group">
                          <v-select
                            class="v-search-select"
                            placeholder="Select month"
                            label="text"
                            v-model="monthFilter"
                            :options="months"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.value"
                            @input="onChangeFilter()"
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="col-sm-5">
                        <div class="form-group">
                          <v-select
                            class="v-search-select"
                            placeholder="Select year"
                            label=""
                            v-model="yearFilter"
                            :options="years"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            @input="onChangeFilter()"
                          >
                          </v-select>
                        </div>
                      </div>
                      <!-- <div class="col-sm-2 plz pt-5">
                        <button class="btn pz">
                          <i class="ic-small-menu pull-left"></i>
                        </button>
                      </div> -->
                    </div>
                  </div>
                </div>
                <!-- /.row -->
              </div>

              <table class="table table-hover mtz">
                <thead>
                  <tr>
                    <th class="number">No.</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Title / Event</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="detail-row"
                    v-for="(item, index) in items"
                    :key="index"
                  >
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ item.typeDescription }}</td>
                    <td>{{ printDate(item) }}</td>
                    <td>{{ item.title }}</td>
                    <td class="text-center">
                      <div class="button-action-wrapper">
                        <button
                          class="btn btn-default"
                          type="button"
                          @click="updateItem(item)"
                        >
                          <span>Edit</span>
                        </button>
                        <button
                          class="btn btn-default"
                          type="button"
                          @click="confirmDelete(item)"
                        >
                          <i class="ic-close"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /.col-sm-8 -->
        </div>
        <!-- /.row -->
      </div>
    </section>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import deleteModal from "@/components/shared/DeleteModal";
import peakPeriodService from "@/services/master/peakPeriod/peakPeriodService.js";
import moment from "moment";

export default {
  components: {
    deleteModal,
  },
  data() {
    return {
      validationErrors: {
        dateRange: null,
        title: null,
      },
      months: [],
      years: [],
      searchFilter: "",
      monthFilter: null,
      yearFilter: null,
      flexDates: [],
      activeTab: "range",
      itemToBeDeleted: null,
      minimumEndDate: null,
      items: [],
      model: {},
      isLoading: false,
      msg: "Please wait",
    };
  },
  async created() {
    try {
      this.$helper.scrollTop();
      this.isLoading = true;
      const dateNow = new Date();
      // this.monthFilter = dateNow.getMonth() + 1;
      // this.yearFilter = dateNow.getFullYear();
      this.months = [];
      this.months.push({ text: "January", value: 1 });
      this.months.push({ text: "February", value: 2 });
      this.months.push({ text: "March", value: 3 });
      this.months.push({ text: "April", value: 4 });
      this.months.push({ text: "May", value: 5 });
      this.months.push({ text: "June", value: 6 });
      this.months.push({ text: "July", value: 7 });
      this.months.push({ text: "August", value: 8 });
      this.months.push({ text: "September", value: 9 });
      this.months.push({ text: "October", value: 10 });
      this.months.push({ text: "November", value: 11 });
      this.months.push({ text: "December", value: 12 });
      this.years = [];
      const previousYear = dateNow.getFullYear() - 1;
      for (let i = 0; i <= 10; i++) {
        this.years.push(previousYear + i);
      }
      this.minimumEndDate = this.$helper.toStringDate(this.$helper.addDays(0));
      this.resetModel();
      await this.getAll();
    } finally {
      this.isLoading = false;
    }
  },
  updated() {
    this.$helper.collapseMenu("administration");
    this.$helper.setNavigationClass("public-holiday-link");
    const self = this;
    $(".startDate-holiday-wrapper .datepicker-day").on("click", function () {
      self.minimumEndDate = self.model.startDate;
    });
  },
  methods: {
    async onSearchTitle() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        await self.getAll();
      }, 500);
    },
    printDate(item) {
      switch (item.typeDescription.toLowerCase()) {
        case "range":
          return (
            moment(new Date(item.startDate)).format("ll") +
            " - " +
            moment(new Date(item.endDate)).format("ll")
          );
        case "flex":
          return moment(new Date(item.startDate)).format("ll");
        case "annual":
          const newDate = new Date(item.startDate);
          newDate.setFullYear(this.yearFilter);
          return moment(newDate).format("ll");
        default:
          return "";
      }
    },
    addFlex() {
      this.flexDates.push({
        startDate: "",
        groupId: null,
        id: null,
      });
    },
    deleteFlex(index) {
      this.flexDates.splice(index, 1);
    },
    resetModel() {
      this.resetValidations();
      this.model = {};
      this.flexDates = [];
      this.addFlex();
    },
    resetValidations() {
      this.validationErrors.dateRange = null;
      this.validationErrors.title = null;
    },
    createItem() {
      this.resetModel();
    },
    async updateItem(item) {
      this.resetValidations();
      this.activeTab = item.typeDescription.toLowerCase();
      switch (this.activeTab) {
        case "range":
          item.dateRange = {
            start: item.startDate,
            end: item.endDate,
          };
          break;
      }
      this.model = Object.assign({}, item);
      this.minimumEndDate = item.startDate;
      switch (this.activeTab) {
        case "range":
          $(this.$refs.linkrange).click();
          break;
        case "flex":
          const peakPeriods = await peakPeriodService.getAllById(item.id);
          this.flexDates = [];
          for (let i = 0; i < peakPeriods.length; i++) {
            this.flexDates.push({
              startDate: peakPeriods[i].startDate,
              groupId: peakPeriods[i].groupId,
              id: peakPeriods[i].id,
            });
          }
          $(this.$refs.linkflex).click();
          break;
        case "annual":
          let newDate = new Date(this.model.startDate);
          newDate.setFullYear(new Date().getFullYear());
          this.model.startDate = `${newDate.getFullYear()}-${
            newDate.getMonth() + 1
          }-${newDate.getDate()}`;
          $(this.$refs.linkannual).click();
          break;
      }
    },
    async onChangeFilter() {
      await this.getAll();
    },
    async getAll() {
      try {
        this.isLoading = true;
        this.items = await peakPeriodService.getAllByFilter(
          this.monthFilter,
          this.yearFilter,
          this.searchFilter
        );
      } finally {
        this.isLoading = false;
      }
    },
    async saveItem() {
      if (!this.$helper.validateForm(this, "peak-period-form")) {
        return;
      }
      try {
        this.isLoading = true;
        const isUpdate = !!this.model.id;
        switch (this.activeTab) {
          case "range":
            this.model.type = 1;
            this.model.startDateCommand = this.$helper.fixDateTime(
              this.model.dateRange.start
            );
            this.model.endDateCommand = this.$helper.fixDateTime(
              this.model.dateRange.end
            );
            delete this.model.flexDatesCommand;
            break;
          case "flex":
            this.model.type = 2;
            delete this.model.startDateCommand;
            delete this.model.endDateCommand;
            this.model.flexDatesCommand = [];
            for (let i = 0; i < this.flexDates.length; i++) {
              this.model.flexDatesCommand.push({
                id: this.flexDates[i].id,
                groupId: this.flexDates[i].groupId,
                startDate: this.$helper.fixDateTime(
                  this.flexDates[i].startDate
                ),
              });
            }
            break;
          case "annual":
            this.model.type = 3;
            this.model.startDateCommand = this.$helper.fixDateTime(
              this.model.startDate
            );
            delete this.model.endDateCommand;
            break;
        }
        if (isUpdate) {
          await peakPeriodService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await peakPeriodService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        this.resetModel();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        item.startDateCommand = this.$helper.fixDateTime(item.stringStartDate);
        item.endDateCommand = this.$helper.fixDateTime(item.stringEndDate);
        await peakPeriodService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await peakPeriodService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.search-wrapper-peak-period {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.search-wrapper-peak-period input {
  display: inline-block;
  width: 100%;
  position: relative;
  border-collapse: separate;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding-left: 43px;
  box-shadow: none;
}

.search-wrapper-peak-period i {
  color: #ccc;
  padding: 0 15px;
  position: absolute;
  left: 0;
  z-index: 2;
  font-size: 1.2rem;
  top: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/peakPeriod/PeakPeriod.vue